import { callApiWithAuthorization } from "../../API/CallApi";

export async function getInstances(projectId) {
    try {
        let request = await callApiWithAuthorization("/api/v0/nodes/" + projectId + "/Instance")
        return await request.json()
    } catch (error) {
        return error
    }
}

export async function compressJson(json) {
    try {
        let request = await callApiWithAuthorization('/api/v0/Zip', {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(json)
        })
        return await request.blob()
    } catch (error) {
        return error
    }
}

export async function updateProjectPortalConfig(projectId) {
    try {
        let request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/updatePortalConfig", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ projectId }),
        });
        return await request.json();
    } catch (error) {
        return error;
    }
}

export async function publishApplication(context, instance, compressJson, isFirstTimePublish = true) {
    var formdata = new FormData();
    formdata.append("file", compressJson)

    let token = localStorage.getItem("accessToken");

    let headers = {
        "Authorization": "Bearer " + token,
    }

    if (!isFirstTimePublish) {
        headers.appId = instance._id
    }
    const url = process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/GenerateAppConfigAndDb"
    let request = await fetch(url, {
        method: "POST",
        headers: headers,
        body: formdata
    })

    let result = await request.json()
    return result
}

export async function getPortalJsonForRuntimeInlineEdit(organizationId, projectId, portalId, instanceId) {
    try {
        const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/portal/" + portalId + "/json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ organizationId, projectId, portalId, instanceId })
        })
        const response = await request.json();
        return response;
    } catch (error) {
        return { error: error.message }
    }
}

export async function publishPortalJsonToRuntime(instanceId, portalId, portalJson) {
    const request = await fetch(
        process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/IncrementalPublishJsonNode?portalId=" + portalId,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "appId": instanceId,
                "nodeName": "portal",
                "Authorization": "Bearer " + localStorage.getItem("accessToken")
            },
            body: JSON.stringify(portalJson)
        }
    );
    const response = await request.json();
    return response;
}

export async function getProductionInstance(projectId) {
    const getProductionInstanceRequest = await callApiWithAuthorization(
        "/api/v0/project/" + projectId + "/productionInstance",
    );
    const productionInstance = await getProductionInstanceRequest.json();
    return productionInstance[0];
}

export function replacePublishErrorTerms(errorMessage) {
    return errorMessage.replace(/entities/gi, "Objects").replace(/attributes/gi, "Properties").replace(/entity/gi, "Object").replace(/attribute/gi, "Property");
}